export const USER_API = '🚀 USER_API';
export const USER_SUCCESS = '✅ USER_SUCCESS';
export const USER_ERROR = '❌ USER_ERROR';
export const CHANGEPWD_API = '🚀 CHANGEPWD_API';
export const CHANGEPWD_SUCCESS = '✅ CHANGEPWD_SUCCESS';
export const CHANGEPWD_ERROR = '❌ CHANGEPWD_ERROR';
export const SUBUSER_API = '🚀 SUBUSER_API';
export const SUBUSER_SUCCESS = '✅ SUBUSER_SUCCESS';
export const SUBUSER_ERROR = '❌ SUBUSER_ERROR';
export const REQUESTS_API = '🚀 REQUESTS_API';
export const REQUESTS_SUCCESS = '✅ REQUESTS_SUCCESS';
export const REQUESTS_ERROR = '❌ REQUESTS_ERROR';
export const REQUEST_API = '🚀 REQUEST_API';
export const REQUEST_SUCCESS = '✅ REQUEST_SUCCESS';
export const REQUEST_ERROR = '❌ REQUEST_ERROR';
export const ROUTES_API = '🚀 ROUTES_API';
export const ROUTES_SUCCESS = '✅ ROUTES_SUCCESS';
export const ROUTES_ERROR = '❌ ROUTES_ERROR';
export const ROUTE_DETAILS_API = '🚀 ROUTE_DETAILS_API';
export const ROUTE_DETAILS_SUCCESS = '✅ ROUTE_DETAILS_SUCCESS';
export const ROUTE_DETAILS_ERROR = '❌ ROUTE_DETAILS_ERROR';
export const FLEETS_API = '🚀 FLEETS_API';
export const FLEETS_SUCCESS = '✅ FLEETS_SUCCESS';
export const FLEETS_ERROR = '❌ FLEETS_ERROR';
export const LOGIN_API = '🚀 LOGIN_API';
export const LOGIN_SUCCESS = '✅ LOGIN_SUCCESS';
export const LOGIN_ERROR = '❌ LOGIN_ERROR';
export const LOGOUT = '❌ LOGOUT';
export const UPDATE_CONTRACT = '⚡ UPDATE_CONTRACT';
export const UPDATE_REQUEST = '⚡ UPDATE_REQUEST';
export const SELECT_SINGLE_CONTRACT = '1⃣ SELECT_SINGLE_CONTRACT';
export const SELECT_ALL_CONTRACTS = '💯 SELECT_ALL_CONTRACTS';
export const UPDATE_CREDITS = '💲 UPDATE_CREDITS';
export const TOGGLE_EXPAND_FLEET = '↔ TOGGLE_EXPAND_FLEET';
export const SET_ROUTES_DATE_FROM = '🕒 SET_ROUTES_DATE_FROM';
export const SET_ROUTES_DATE_TO = '🕒 SET_ROUTES_DATE_TO';
export const RESET_PASSWORD_API = 'RESET_PASSWORD_API'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'
